import React from 'react';
import { usePageContent } from '../../services/contentService';
import LoadingOverlay from '../../components/LoadingOverlay';
import './YOCILABAcademy.css';
import SEO from '../../components/SEO';

const YOCILABAcademy = () => {
  const { content, loading, error } = usePageContent('yocilab-academy');

  const containerStyle = {
    maxWidth: '1200px',
    margin: '0 auto',
    padding: window.innerWidth <= 768 ? '0 1rem' : '0 2rem'
  };

  if (loading || !content) {
    return <LoadingOverlay />;
  }

  if (error) {
    return (
      <div className="error-state">
        <p>Error loading content: {error}</p>
      </div>
    );
  }

  // Get sections from content
  const heroSection = content?.sections?.find(s => s.type === 'page-hero')?.content;
  const programsSection = content?.sections?.find(s => s.type === 'programs-grid')?.content;

  return (
    <div className="yocilab-academy-page">
      <SEO
        title="YOCILAB Academy"
        description="Our flagship EdTech learning platform equipping young people with job readiness, entrepreneurship, and innovation skills."
      />
      {/* Main Academy Section */}
      <div className="academy-main-section">
        <div style={containerStyle}>
          <div className="academy-section-header">
            <span className="academy-section-label">YOCILAB ACADEMY</span>
          </div>
          <div className="academy-content">
            <div className="academy-image-section">
              <img
                src={require('../../assets/YOCILAB/digital tech initiative_051535.JPG')}
                alt="YOCILAB Academy digital skills training"
                className="academy-hero-image"
              />
              <div className="academy-image-overlay-content">
                <h1 className="academy-hero-title">
                  {heroSection?.mainTitle || "YOCILAB Academy"}
                </h1>
                <button className="academy-cta-button">EXPLORE OUR PROGRAMS</button>
              </div>
            </div>
            <div className="academy-content-section">
              <p className="academy-main-description">
                {heroSection?.subtitle || "YOCILAB Academy is our flagship EdTech learning platform that equips young people with job readiness, entrepreneurship, and innovation skills."}
              </p>
              <p className="academy-detailed-description">
                {heroSection?.description || "Through blended learning, mentorship, and project-based experiences, we prepare young people to compete globally while solving local challenges. Our comprehensive programs combine theoretical knowledge with practical application, ensuring graduates are ready for the modern economy."}
              </p>
            </div>
          </div>
        </div>
      </div>

      {/* What We Do Section */}
      <div className="academy-programs-section">
        <div style={containerStyle}>
          <div className="programs-header">
            <h2 className="programs-title">Our Programs</h2>
            <p className="programs-description">
              Comprehensive learning experiences designed to empower young people with the skills they need to thrive.
            </p>
          </div>

          {/* Spark+ Program */}
          <div className="program-section spark-program">
            <div className="program-content">
              <div className="program-text">
                <h3 className="program-title">Spark+</h3>
                <p className="program-subtitle">For ages 14-18</p>
                <p className="program-description">
                  An innovative program designed to ignite creativity and entrepreneurial thinking
                  in high school students, preparing them for future leadership roles.
                </p>
                <ul className="program-features">
                  <li>Innovation and Design Thinking</li>
                  <li>Entrepreneurship Fundamentals</li>
                  <li>Digital Skills Development</li>
                  <li>Team Building and Collaboration</li>
                </ul>
                <button className="program-btn">Bring SPARK+ to Your School</button>
              </div>
              <div className="program-image">
                <img
                  src={require('../../assets/YOCILAB/DSC_7431.jpg')}
                  alt="Spark+ program students"
                />
              </div>
            </div>
          </div>

          {/* Changemakers School */}
          <div className="program-section changemakers-program">
            <div className="program-content changemakers-card">
              <div className="program-text">
                <h3 className="program-title">Changemakers School</h3>
                <p className="program-subtitle">For Future Social Impact Leaders</p>
                <div className="learning-section">
                  <h4 className="learning-title">What You'll Learn</h4>
                  <p>Participants gain hands-on skills in:</p>
                  <ul className="learning-list">
                    <li>Design Thinking & Innovation</li>
                    <li>Social Entrepreneurship</li>
                    <li>Leadership & Personal Growth</li>
                    <li>Community Engagement</li>
                    <li>Communication & Storytelling</li>
                    <li>Fundraising & Sustainability</li>
                  </ul>
                </div>
                <button className="program-btn">Apply Now</button>
                <p className="application-note">
                  Application for the next cohort of changemakers school will open in early 2026.
                </p>
              </div>
              <div className="program-image">
                <img
                  src={require('../../assets/YOCILAB/DSC_3053.jpg')}
                  alt="Changemakers School participants"
                />
              </div>
            </div>
          </div>

          {/* Young Graduates Fellowship */}
          <div className="program-section fellowship-program">
            <div className="program-content fellowship-hero">
              <div className="program-text">
                <h3 className="program-title">Young Graduates Fellowship</h3>
                <p className="program-subtitle">For Recent Graduates</p>
                <p className="program-description">
                  A comprehensive fellowship program that bridges the gap between education and
                  employment, providing recent graduates with practical skills, mentorship,
                  and career opportunities.
                </p>
                <ul className="program-features">
                  <li>Professional Skills Development</li>
                  <li>Industry Mentorship</li>
                  <li>Project-Based Learning</li>
                  <li>Career Placement Support</li>
                </ul>
                <button className="program-btn">Apply Now</button>
              </div>
              <div className="program-image">
                <img
                  src={require('../../assets/YOCILAB/image_4494eb23-aa00-4436-9932-813623d55b4b20230127_122928 (1)_095109.jpg')}
                  alt="Young Graduates Fellowship"
                />
              </div>
            </div>
          </div>
        </div>
      </div>

      {/* Call to Action Section */}
      <div className="academy-final-cta">
        <div style={containerStyle}>
          <div className="final-cta-content">
            <h2 className="final-cta-title">Let's Build the Future—Together.</h2>
            <p className="final-cta-description">
              We believe that talent is universal, but opportunities are not.
              We're here to change that - one young person at a time.
            </p>
            <p className="final-cta-question">Are you ready?</p>
            <div className="final-cta-buttons">
              <button className="sponsor-btn">Sponsor a Youth</button>
              <button className="explore-btn">Explore Our Programs</button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default YOCILABAcademy;